<template>
    <div class="fs5-dashboard-tutorial">
        <div class='button-wrapper'>
            <fs5-button 
                v-for="(value, name, index) in sanitizedHeader"
                :key="index"
                :label="value"
                :btn-type="buttonActive == index ? 'primary' : ''"
                :text-transform-type="'capitalize'"
                :is-new="view.show_is_new_badge"
                :translations="view.translation"
                @clicked="handleVideo(index+1)"
            ></fs5-button>
        </div>
        <div class='video-wrapper'>
            <div class="container__youtube">
                <iframe
                    :src="jsIframe_src"
                    frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                ></iframe> <!-- allData.url_video_rank['0'] -->
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "fs5-dashboard-tutorial",
        props: ['view'],
        data() {
            return {
                jsIframe_src: '',
                buttonActive: -1
            }
        },
        methods: {
            handleVideo(data) {
                this.buttonActive = data-1
                if (data == 1)
                    this.jsIframe_src = this.sanitizedUrls["1"];
                if (data == 2)
                    this.jsIframe_src = this.sanitizedUrls["2"];
                if (data == 3)
                    this.jsIframe_src = this.sanitizedUrls["3"];
                if (data == 4)
                    this.jsIframe_src = this.sanitizedUrls["4"];
                if (data == 5)
                    this.jsIframe_src = this.sanitizedUrls["5"];
            },
            isEmpty(val) {
                return ( val === undefined || val === null || val.trim() == '' )
            }
        },
        created(){
            this.jsIframe_src = this.view.urls["0"]
            
        },
        mounted(){
        },
        computed: {
            sanitizedHeader() {
                let arr = {};
                let i = 0;
                for(let key in this.view.translation.header) {
                    if( !this.isEmpty( this.view.urls[(i+1)+''] )  ) {
                        arr[key] = this.view.translation.header[key];
                    }
                    i++;
                }
                return arr;
            },
            sanitizedUrls() {
                let arr = [];
                let len = this.view.urls.length;
                for( let i = 0; i < len; i++ ) {
                    if( !this.isEmpty( this.view.urls[i+''] )  ) {
                        arr.push( this.view.urls[i+''] );
                    }
                }
                return arr;
            },
        }
    }
</script>

<style scoped lang="scss">
    @import '../../../../../scss/extras/_variables';
    .fs5-dashboard-tutorial{
        font: inherit;
        font-size: 0.625rem;
        border-radius: 0.8em;
        border: 1px $fs5-color1 solid;
        background-color: $fs5-color2;
        padding: 3.4em 2.2em;

        display: grid;
        grid-template-columns: 23.83% auto;
        grid-template-rows: auto;
        column-gap: 1.97%;
        .button-wrapper{
            font: inherit;
            display: flex;
            flex-direction: column;
            align-items: stretch;
            justify-content: stretch;
            row-gap: 3em;
            
        }
        .video-wrapper{
            font: inherit;
            .container__youtube {
                border-radius: 4px;
            }
        }
    }

    @media screen and (max-width: 1199px) {
        .fs5-dashboard-tutorial{
            grid-template-columns: 1fr;
            grid-template-rows: auto auto;
            row-gap: 3em;
        }
    }
</style>


// WEBPACK FOOTER //
// resources/office/js/components/franchise_v5/affiliate_dashboard/dashboard_tutorial/index.vue